import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { TextSize } from '@/features/common/components/Overview/parts/ProductItem/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface PriceProps {
    children: string
    textSize: TextSize
}

const Price: FC<PriceProps> = ({ children, textSize }) => {
    return (
        <Typography.Description size={textSize} font="regular" style={styles.optionPrice}>
            {children}
        </Typography.Description>
    )
}

export default Price
